<div class="career-plan-position">
  <div class="career-plan-position__left">
    <span class="bar-decorator"> </span>
  </div>
  <div class="career-plan-position__right">
    <div class="career-plan-position__right__position-type">
      <span *ngIf="positionType === 'ACTUAL'">{{ 'careerPlans.position.actual' | translate }}</span>
      <span *ngIf="positionType === 'FUTURE'">{{ 'careerPlans.position.future' | translate }}</span>
    </div>
    <div class="career-plan-position__right__position-name">
      <span [class.career-plan-position__right__position-name--accent]="positionType === 'FUTURE'"
        >{{ positionName }}</span
      >
    </div>
  </div>
</div>
